import { render, staticRenderFns } from "./OtherApDetail.vue?vue&type=template&id=4c9a7bc2&scoped=true"
import script from "./OtherApDetail.vue?vue&type=script&lang=js"
export * from "./OtherApDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherApDetail.vue?vue&type=style&index=0&id=4c9a7bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a7bc2",
  null
  
)

export default component.exports